export default {
  productionAPI: "https://api.jets-qsms.com/api",
  devAPI: "http://localhost:5050/api",
  pathAPI: "https://api.jets-qsms.com/api"
  // pathAPI:       "http://localhost:5050/api",
};
